export function useBookboostApi() {
    interface BookboostOptions {
        listId: string;
        consentId: string;
        email: string;
        firstName?: string;
        lastName?: string;
        phone?: string;
        tags?: string[];
    }

    const storeUserInList = async(bookboostOptions: BookboostOptions) => {
        try {
            const response = await $fetch('/api/bookboost', {
                method: 'POST',
                body: bookboostOptions
            });

            console.log('User stored in Bookboost:', response);
            return response;
        } catch (error) {
            console.error('Error storing user in Bookboost:', error);
            throw error;
        }
    };

    return {
        storeUserInList
    };
}